var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "system-simulation-payment" },
    [
      _c("div", { staticClass: "page-title application-detail-header" }, [
        _vm._v(" " + _vm._s(_vm.$t("menu.simulation_dynamic_payment")) + " "),
      ]),
      _c("p", { staticStyle: { color: "red", "white-space": "pre-line" } }, [
        _vm._v(_vm._s(_vm.$t("system.simulation_warning"))),
      ]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "text item" },
          [
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  model: _vm.search,
                  "label-width": "150px",
                  "label-position": "left",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("system.mch_order_id"),
                      prop: "mch_order_id",
                      required: "",
                    },
                  },
                  [
                    _c("el-input", {
                      staticClass: "search-frame",
                      attrs: {
                        size: "small",
                        placeholder: _vm.$t("system.mch_order_id"),
                        autocomplete: "off",
                        clearable: "",
                      },
                      model: {
                        value: _vm.search.mch_order_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "mch_order_id", $$v)
                        },
                        expression: "search.mch_order_id",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("merchantAccount.transaction_status"),
                      prop: "transaction_status",
                      required: "",
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "search-frame",
                        attrs: { size: "small", clearable: "" },
                        model: {
                          value: _vm.search.transaction_status,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "transaction_status", $$v)
                          },
                          expression: "search.transaction_status",
                        },
                      },
                      _vm._l(
                        _vm.payTransactionStatusArr,
                        function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
                _vm.$store.getters.isRussia
                  ? _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("system.channel_code"),
                          prop: "channel_code",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "search-frame",
                          attrs: {
                            size: "small",
                            placeholder: _vm.$t("system.channel_code"),
                            autocomplete: "off",
                            clearable: "",
                          },
                          model: {
                            value: _vm.search.channel_code,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "channel_code", $$v)
                            },
                            expression: "search.channel_code",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: _vm.listLoading },
                        on: {
                          click: function ($event) {
                            return _vm.onSubmit("form")
                          },
                        },
                      },
                      [_vm._v("Submit")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }